import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

import { SignedInRootStackParamList } from '../../../../routes/types';
import { updateMovementFilterParamsSelector, updateMovementOptionSelector } from '../selectors';
import { MovementOptionQuery, MovementsFilterParamsProps } from '../types';

export const useMovementsActions = (pageParams?: SignedInRootStackParamList['CustomerDetail']) => {
  const setMovementOption = useSetRecoilState(updateMovementOptionSelector);
  const setMovementsFilterParams = useSetRecoilState(updateMovementFilterParamsSelector);

  const updateMovementOption = (value: MovementOptionQuery) => {
    setMovementOption(value);
  };

  const updateMovementsFilterParams = (value: Partial<MovementsFilterParamsProps>) => {
    const data = value as MovementsFilterParamsProps;
    setMovementsFilterParams(data);
  };

  useEffect(() => {
    if (pageParams?.movementInitialTab) {
      updateMovementOption(pageParams.movementInitialTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageParams]);

  return { updateMovementOption, updateMovementsFilterParams };
};
